import UserRolesForm from "../../components/views/user-roles";

function UserRolesPage() {
  return <UserRolesForm />;
}
export default UserRolesPage;
